/* Pretty Panther — images ready before you get to them.
   Phones and tablets only start loading a "lazy" photo when it is almost on screen, and photos further along a
   slider only when that slider is swiped, so they appeared late. Here every photo starts loading well before it
   comes into view: a whole slider as soon as it gets near the screen, other photos one and a half screens ahead. */
(() => {
  if (window.__ppDeviceFixes) return;
  window.__ppDeviceFixes = true;

  const SLIDERS = '.pp-carousel__list, .pp-tiles--carousel .pp-tiles__list, .pp-gallery__track, .pp-qv__track, .pp-logos--row, .pp-logos--fill, [data-pp-scroller]';
  const eager = (img) => {
    if (img.loading === 'lazy') img.loading = 'eager';
    if (!img.decoding || img.decoding === 'auto') img.decoding = 'async';
  };

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('img[loading="lazy"]').forEach(eager);
    return;
  }

  const sliderIO = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.querySelectorAll('img[loading="lazy"]').forEach(eager);
      sliderIO.unobserve(e.target);
    });
  }, { rootMargin: '100% 0px 100% 0px' });

  const imgIO = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      eager(e.target);
      imgIO.unobserve(e.target);
    });
  }, { rootMargin: '150% 0px 150% 0px' });

  const seen = new WeakSet();
  const scan = (root) => {
    (root || document).querySelectorAll(SLIDERS).forEach((s) => {
      if (seen.has(s)) return;
      seen.add(s);
      sliderIO.observe(s);
    });
    (root || document).querySelectorAll('img[loading="lazy"]').forEach((img) => {
      if (seen.has(img) || img.closest(SLIDERS)) return;
      seen.add(img);
      imgIO.observe(img);
    });
  };

  const start = () => {
    scan();
    // Grids that load more products, the bag, quick view and section reloads add new photos later
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; scan(); });
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  // Coming back with the Back button or a swipe: Safari restores the page from memory; make sure nothing waits
  window.addEventListener('pageshow', (e) => { if (e.persisted) scan(); });
})();

/* The page never stays shifted sideways (iPhone: swiping showed a white strip on the right).
   Unless the visitor has zoomed in with two fingers, any sideways scroll of the page snaps straight back. */
(() => {
  if (window.__ppNoSideways) return;
  window.__ppNoSideways = true;
  const zoomed = () => window.visualViewport && window.visualViewport.scale > 1.01;
  const fix = () => {
    if (zoomed()) return;
    if (window.scrollX) window.scrollTo(0, window.scrollY);
    [document.documentElement, document.body, document.querySelector('.page-wrapper'), document.querySelector('#MainContent')].forEach((el) => {
      if (el && el.scrollLeft) el.scrollLeft = 0;
    });
  };
  window.addEventListener('scroll', fix, { passive: true });
  document.addEventListener('scroll', fix, { passive: true, capture: true });
  window.addEventListener('resize', fix);
  window.addEventListener('orientationchange', () => setTimeout(fix, 300));
  window.addEventListener('pageshow', fix);
  fix();
})();
